import {
  RECEIVE_RESTROOMS
} from "../actions";

const initialState = {
  restrooms: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_RESTROOMS:
      return {
        ...state,
        restrooms: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
